import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl,Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import { ToastService } from 'src/app/core/services/misc/toast.service';

@Component({
  selector: 'app-coronary-angiogram',
  templateUrl: './coronary-angiogram.component.html',
  styleUrls: ['./coronary-angiogram.component.scss']
})
export class CoronaryAngiogramComponent implements OnInit {


  coronary_angiogram_form = new FormGroup({
    name: new FormControl('', Validators.compose([ Validators.required,])),
    value1: new FormControl(''),
    value2: new FormControl(''),
    value3: new FormControl(''),
    date: new FormControl(''),
    remarks: new FormControl(''),
  });

  constructor(
    private matDialogRef: MatDialogRef<any>,
    private toast: ToastService,
    ) {}

  ngOnInit(): void {
  }

  save() {
    if(this.coronary_angiogram_form.value.name){
      const object = this.coronary_angiogram_form.value;
      object.is_default = false
      object.selected = true
      this.matDialogRef.close(object);
    }else{
      this.toast.showError('Please Enter Name');
    }

  }
}

